import { useMemo } from 'react';
import { Column, Typography } from '@tempmee/react';
import { UserProfession } from '~/enums/UserProfession';
import { IJob, IUser, ProfessionTypeEnum } from '~/models';
import { TNullable } from '~/types/Nullable';
import { EducationUtils } from '~/utils/EducationUtils';
import { filterObjectKeys } from '~/utils/Object';

interface IRdhFdProceduresProps {
  job: TNullable<IJob>;
  professional: TNullable<IUser>;
}

export const RdhFdProcedures = ({ professional, job }: IRdhFdProceduresProps) => {
  const candidateEducation = professional?.professional_info?.education;
  const candidateProfession = professional?.license?.profession;
  const profession = (job?.profession || candidateProfession) as ProfessionTypeEnum;
  const candidateSpecialtiesAndProcedures =
    candidateEducation?.[profession]?.specialtiesAndProcedures;
  const specialties = useMemo(
    () => Object.keys(filterObjectKeys(candidateSpecialtiesAndProcedures, 'specialty')),
    [candidateSpecialtiesAndProcedures],
  );

  const procedures = useMemo(
    () =>
      EducationUtils.getProceduresOfProfession({
        specialtiesAndProcedures: candidateSpecialtiesAndProcedures,
        profession: candidateProfession,
        specialties,
      }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [candidateEducation, job?.profession],
  );

  return (
    [UserProfession.RDH, UserProfession.FD].includes(profession) && (
      <Column gap={2} style={{ marginLeft: 8, marginTop: 12 }}>
        {procedures.map((name) => (
          <Typography as="span" key={name}>{`\u2022  ${EducationUtils.removeProcedurePrefix(name)}`}</Typography>
        ))}
      </Column>
    )
  );
};
